import moment from "moment";

export const generateTimesForInterval = (interval_min, interval_sec) => {
  const start_time = moment().startOf("day");
  const max_time = moment().endOf("day");
  var running_time = start_time;
  var time_set = [];
  var interval = interval_min * 60 * 1000 + interval_sec * 1000;
  while (running_time < max_time) {
    time_set.push(running_time);
    running_time = running_time + interval;
  }
  return time_set;
};
